<template>
    <div>
      <div class="top-box">
        <div class="backgroud-item">
          <img
            src="http://a1.yujianquancheng.com/wtos/public/e226afefc3a5b227.jpg"
          />
        </div>
  
        <div v-if="userInfo" class="user-info-box">
          <div class="user-avatar">
            <img :src="userInfo.avatar.url" alt="" v-if="userInfo.avatar" />
          </div>
          <div class="right">
            <div class="user-nickname">{{ userInfo.nickname }}</div>
            <div class="description">开通畅读会员 数万内容任你看</div>
          </div>
        </div>
      </div>
  
      <PayCard scene="story_vip"  :refer="refer"> </PayCard>
    </div>
  </template>
  
  <script>
  import PayCard from "@/components/common/PayCard.vue";
  
  export default {
    name: "VipCashier",
    components: {
      PayCard,
    },
    props: {
    },
    data() {
      return {
        userInfo: null,
        refer: "",
      };
    },
    mounted() {
      this.refer = this.$store.getters.getRefer
      this.loadUserInfo();
    },
    methods: {
      loadUserInfo() {
        this.$store.dispatch("AccountInfoMine").then((data) => {
          if (data.code === 0) {
            this.userInfo = data.data;
          }
        });
      },

    }
  };
  </script>
  
  <style lang="scss" scoped>
  .top-box {
    width: 100%;
    height: 33vw;
    max-height: 380px;
    position: relative;
  
    .backgroud-item {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
      object-fit: cover;
  
      img {
        width: 100%;
      }
    }
  }
  
  .user-info-box {
    position: absolute;
    bottom: 5vw;
    left: 0;
    padding: 0 25px;
    display: flex;
    align-items: center;
  
    .user-avatar {
      width: 15vw;
      height: 15vw;
      border-radius: 50%;
      overflow: hidden;
  
      img {
        width: 100%;
        height: 100%;
      }
    }
  
    .right {
      display: flex;
      flex-direction: column;
      margin-left: 12px;
  
      .user-nickname {
        font-size: 16px;
        color: bisque;
      }
  
      .description {
          margin-top: 8px;
          color: bisque;
          font-size: 12px;
      }
    }
  }
  </style>
  